<template>
    <div class="product-detail common-detail">
        <div class="product-detail-banner">
            <div class="banner-content">
                <div class="left">
                <!-- <div><span>乐分享在线考试系统</span></div>
                <div></div>
                <div>跨平台、多方位的考试系统<br>PC、移动端、微信小程序等均可进行考试<br>防作弊；拍照上传</div> -->
                <div class="btns">
                    <div @click="toTry">立即试用</div>
                    <div @click="handle">视频教程</div>
                </div>
                </div>
            </div>
        </div>
        <div class="item1">
            <div class="item1-header">
                <div class="title">乐分享在线考试系统</div>
                <div class="sub-title">跨平台、多方位的考试系统，PC、移动端、微信小程序等均可进行考试</div>
            </div>
            <div class="item1-wrapper">
                <div class="card" id="card1" :class="animateObj['#card1'] ? 'ani' : ''">
                    <div>试题上传</div>
                    <div>一键上传，快速考试(一站式操作，简洁明了， 上传即考试)</div>
                </div>
                <div class="card" id="card2" :class="animateObj['#card2'] ? 'ani' : ''">
                    <div>防作弊</div>
                    <div>考试防作弊(公平公正的考试，严肃考 试，杜绝作弊)</div>
                </div>
                <div class="card" id="card3" :class="animateObj['#card3'] ? 'ani' : ''">
                    <div>答题多样化</div>
                    <div>答题多样化(手写答案可进行拍照上传 答案，避免复杂答案无法答题)</div>
                </div>
                <div class="card" id="card4" :class="animateObj['#card4'] ? 'ani' : ''">
                    <div>错题集</div>
                    <div>自动生成错题集(针对错题进行练习，查缺补漏) 错题集支持下载打印(方便保存，共享难题、错题)</div>
                </div>
                <div class="card" id="card5" :class="animateObj['#card5'] ? 'ani' : ''">
                    <div>答题方式</div>
                    <div>灵活、多样化，避免考试的单一选择</div>
                </div>
                <div class="card" id="card6" :class="animateObj['#card6'] ? 'ani' : ''">
                    <div>考试成绩</div>
                    <div>自动评分(智能评分，准确无误)成绩自动分析 (答案、解析一目了然，快速定位问题)</div>
                </div>
            </div>
        </div>
        <div class="item2">
            <div class="item2-wrapper">
                <ul class="list">
                    <li id="item1" :class="animateObj['#item1'] ? 'ani' : ''">
                        <div>
                            <img :src="img1" alt="">
                        </div>
                        <div>
                            <div>多种考试方式</div>
                            <div>突破考试方式的局限性，<br> 提供多种方式进行考试。</div>
                        </div>
                    </li>
                    <li id="item2" :class="animateObj['#item2'] ? 'ani' : ''">
                        <div>
                            <img :src="img1" alt="">
                        </div>
                        <div>
                            <div>多功能</div>
                            <div>错题集支持下载打印<br>(方便 保存，共享难题、错题)</div>
                        </div>
                    </li>
                    <li id="item3" :class="animateObj['#item3'] ? 'ani' : ''">
                        <div>
                            <img :src="img1" alt="">
                        </div>
                        <div>
                            <div>上传即考试</div>
                            <div>快速完成上传，上传试题<br>完成后可立即考试。</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="item3">
            <div class="title">特别功能</div>
            <el-tabs>
                <el-tab-pane>
                    <span slot="label"><i class="el-icon-date"></i> 评分功能</span>
                    <div class="tab-wrapper">
                        <div class="left">
                            <div style="margin-top:50px">功能介绍</div>
                            <div>
                                自动评分(智能评分，准确无误)让用户更加快捷的 得到评分，使用方便。
                            </div>
                            <div class="btn" style="margin-top:25px">
                                <el-button type="warning" @click="toTry">点击试用</el-button>
                            </div>
                        </div>
                        <div class="right">
                            <img :src="online1" alt="" @click="zoomIn(online1)">
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="多平台">
                    <span slot="label"><i class="el-icon-date"></i> 多平台</span>
                    <div class="tab-wrapper">
                        <div class="left">
                            <div style="margin-top:50px">功能介绍</div>
                            <div>
                                跨平台、多方位的考试系统，PC、移动端、微信小程序等均可进行考试。
                            </div>
                            <div class="btn" style="margin-top:25px">
                                <el-button type="warning" @click="toTry">点击试用</el-button>
                            </div>
                        </div>
                        <div class="right">
                            <!-- <img :src="img2" alt=""> -->
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="防作弊">
                    <span slot="label"><i class="el-icon-date"></i> 防作弊</span>
                    <div class="tab-wrapper">
                        <div class="left">
                            <div style="margin-top:50px">功能介绍</div>
                            <div>
                                公平公正的考试，严肃考试，杜绝作弊
                            </div>
                            <div class="btn" style="margin-top:25px">
                                <el-button type="warning" @click="toTry">点击试用</el-button>
                            </div>
                        </div>
                        <div class="right">
                            <!-- <img :src="img2" alt=""> -->
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="错题下载">
                    <span slot="label"><i class="el-icon-date"></i> 错题下载</span>
                    <div class="tab-wrapper">
                        <div class="left">
                            <div style="margin-top:50px">功能介绍</div>
                            <div>
                                方便保存，共享错题，针对性练习
                            </div>
                            <div class="btn" style="margin-top:25px">
                                <el-button type="warning" @click="toTry">点击试用</el-button>
                            </div>
                        </div>
                        <div class="right">
                            <!-- <img :src="img2" alt=""> -->
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        
        <div class="video-wrapper" v-if="showVideo">
            <div class="video-content">
                <div class="close"><i class="el-icon-error" @click="close"></i></div>
                <video-player  class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions"
                ></video-player>
            </div>
        </div>
        <transition name="fade">
            <div class="mask" v-show="preShow" @click="zoomOut">
                <div class="img-main">
                    <img :src="preImg" alt="">
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
export default {
    data(){
        return {
            preImg: '',
            preShow: false,
            path: process.env.BASE_URL,
            img1: require('@/assets/icon_ys.png'),
            img2: require('@/assets/img_3.png'),
            sc: require('@/assets/icon_sc.png'),
            gl: require('@/assets/icon_gl.png'),
            ctb: require('@/assets/icon_ctb.png'),
            sg: require('@/assets/icon_sg.png'),
            xz: require('@/assets/cion_xz.png'),
            sjk: require('@/assets/icon_sjk.png'),
            zj: require('@/assets/icon_zj.png'),
            online1: require('@/assets/online1.jpeg'),
            showVideo: false,
            playerOptions : {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                src: `${process.env.BASE_URL}video/demo.mp4`,  // 路径
                type: 'video/mp4'  // 类型
                }],
                // poster: require('@/assets/logo.png'), //你的封面地址
                // width: document.documentElement.clientWidth,
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                timeDivider: true,
                durationDisplay: true,
                remainingTimeDisplay: false,
                fullscreenToggle: true  //全屏按钮
                }
            },
            animateObj: {
                '#card1': false,
                '#card2': false,
                '#card3': false,
                '#card4': false,
                '#card5': false,
                '#card6': false,
                '#item1': false,
                '#item2': false,
                '#item3': false,
            }
        }
    },
    components: {
        videoPlayer
    },
    methods: {
        // 点击图片放大
        zoomIn(src){
            this.preImg = src;
            this.preShow = true;
        },
        // 点击图片缩小
        zoomOut(){
            this.preShow = false;
        },
        toTry(){
            window.open(IPConfig.examUrl);
        },
        handle(){
            this.playerOptions.sources = [{
                src: `${this.path}video/productIntro/exam.mp4`,  // 路径
                type: 'video/mp4'  // 类型
            }];
            this.showVideo = true;
        },
        toLook(){
            this.showVideo = true;
        },
        close(){
            this.showVideo = false;
        },
        handleScroll () {
            this.preShow = false;
            // var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            var w = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            for(var key in this.animateObj){
                var offsetTop = document.querySelector(key).getBoundingClientRect().top;
                if(offsetTop < w){
                    this.animateObj[key] = true;
                }else{
                    this.animateObj[key] = false;
                }
            }
        },
    },
    destroyed(){
        window.removeEventListener('scroll', this.handleScroll);
    },
    mounted(){
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
    }
}
</script>
<style lang="less">
    @import './css/product.less';
    .product-detail{
        .ani{
            transform: translateZ(0)!important;
            opacity: 1!important;
        }
        .product-detail-banner{
            height: 730px;
            background: #198AF7 url('../assets/home_4.png') no-repeat center center;
            background-size: auto 100%;
            .banner-content{
                .left{
                    right: 0;
                    bottom: 30px;
                }
            }
        }
        .item1{
            width: 1200px;
            margin: 0 auto;
            height: 760px;
            display: flex;
            flex-direction: column;
            background: url('../assets/img_ji.png') no-repeat center center;
            .item1-header{
                text-align: center;
                padding-top: 60px;
                .title{
                    font-size: 40px;
                    color: #F88927;
                    margin-bottom: 10px;
                }
                .sub-title{
                    font-size: 18px;
                    color: #A9A9A9;
                }
            }
            .item1-wrapper{
                flex: 1;
                position: relative;
                .card{
                    position: absolute;
                    width: 312px;
                    transition: all 0.6s;
                    transform: translate3d(0,100px,0);
                    opacity: 0;
                    >div{
                        &:nth-of-type(1){
                            font-size: 24px;
                            text-align: right;
                        }
                        &:nth-of-type(2){
                            text-align: left;
                            font-size: 14px;
                            color: #A9A9A9;
                        }
                    }
                    &:nth-of-type(1){
                        top: 70px;
                        width: 295px;
                        left: 50px;
                    }
                    &:nth-of-type(2){
                        top: 260px;
                        width: 247px;
                        left: 22px;
                    }
                    &:nth-of-type(3){
                        top: 430px;
                        width: 284px;
                        left: 63px;
                    }
                    &:nth-of-type(4),&:nth-of-type(5),&:nth-of-type(6){
                        >div{
                            &:nth-of-type(1){
                                text-align: left;
                            }
                            &:nth-of-type(2){
                                text-align: left;
                            }
                        }
                    }
                    &:nth-of-type(4){
                        top: 70px;
                        left: 860px;
                    }
                    &:nth-of-type(5){
                        top: 260px;
                        left: 930px;
                    }
                    &:nth-of-type(6){
                        top: 430px;
                        left: 860px;
                    }
                    
                }
            }
        }
        .item2{
            background: url('../assets/img_bj.png') no-repeat center center;
            height: 482px;
            .item2-wrapper{
                width: 1200px;
                margin: 0 auto;
                .list{
                    display: flex;
                    justify-content: space-between;
                    height: 100%;
                    padding-top: 200px;
                    box-sizing: border-box;
                    li{
                        display: flex;
                        transition: all 0.6s;
                        transform: translate3d(0,100px,0);
                        opacity: 0;
                        &:nth-of-type(2){
                            transition-delay: 0.3s;
                        }
                        &:nth-of-type(3){
                            transition-delay: 0.6s;
                        }
                        >div{
                            &:nth-of-type(2){
                                margin-left: 20px;
                                color: #fff;
                                div:nth-of-type(1){
                                    font-size: 24px;
                                    margin-bottom: 10px;
                                }
                                div:nth-of-type(2){
                                    font-size: 18px;
                                }
                            }
                        }
                    }
                }
            }
        }
        .item3{
            padding: 100px 0;
            width: 1200px;
            margin: 0 auto;
            .title{
                font-size: 36px;
                text-align: center;
                margin-bottom: 50px;
            }
            .el-tabs__item{
                font-size: 20px;
                color: #536174;
            }
            .tab-wrapper{
                display: flex;
                .left{
                    flex: 1;
                    >div{
                        &:nth-of-type(1){
                            font-size: 24px;
                            margin: 30px 0;
                        }
                        &:nth-of-type(2){
                            font-size: 18px;
                            color: #8F8F8F;
                        }
                    }
                }
                .right{
                    flex: 1;
                    img{
                        width: 100%;
                        height: 336px;
                        object-fit: contain;
                        cursor: zoom-in;
                    }
                }
            }
        }
        
        .item5{
            width: 1200px;
            margin: 0 auto;
            padding: 100px 0;
            .title{
                font-size: 36px;
                text-align: center;
                margin-bottom: 60px;
            }
            .list{
                display: flex;
                flex-wrap: wrap;
                .item{
                    width:163px;
                    height:54px;
                    background:rgba(255,255,255,1);
                    box-shadow:0px 4px 16px 0px rgba(158,158,158,0.4);
                    margin-right: 43px;
                    margin-bottom: 28px;
                    &:nth-of-type(6n){
                        margin-right: 0;
                    }
                }
            }
        }
        .video-wrapper{
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: rgba(0, 0, 0, 0.3);
            z-index: 9999;
            .video-content{
                position: absolute;
                top: 50%;
                left: 50%;
                width: 900px;
                transform: translate(-50%,-50%);
                .close{
                    text-align: right;
                    font-size: 50px;
                    color: #fff;
                    .el-icon-error{
                        cursor: pointer;
                    }
                }
                .video-player{
                    .vjs-big-play-button{
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
            }
        }
    }
</style>